import { Controller } from '@hotwired/stimulus';
import validate from '../../modules/validate/index';
import clearInvalidInputsOnChange from '../../modules/enterpriseAdmin/clearInvalidFlags';

export default class extends Controller {
  connect () {
    validate('form-without-labels');
    validate('form-floating-labels');
    clearInvalidInputsOnChange();
  }

  // eslint-disable-next-line class-methods-use-this
  disconnect () {
    clearInvalidInputsOnChange(false);
  }
}
